(function () {
  var MOBILE_BREAKPOINT = 1165;

  function isMobileView() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function saveOriginalHtml(root) {
    if (!root.dataset.originalHtml) {
      root.dataset.originalHtml = root.innerHTML;
    }
  }

  function restoreOriginalHtml(root) {
    if (root.dataset.originalHtml) {
      root.innerHTML = root.dataset.originalHtml;
    }
  }

  function flattenForMobile(root) {
    var fragment = document.createDocumentFragment();

    root.querySelectorAll('.lv3-reviews-slider-item').forEach(function (item) {
      var wrap = item.querySelector('.lv3-reviews-slider-item-wrap');
      if (!wrap) return;

      var parts = [
        wrap.querySelector('.lv3-reviews-slider-item-data'),
        wrap.querySelector('.lv3-reviews-slider-item-img'),
      ];

      parts.forEach(function (part) {
        if (!part) return;

        var slide = document.createElement('div');
        slide.className = 'lv3-reviews-slider-item lv3-reviews-slider-item--single';

        var newWrap = document.createElement('div');
        newWrap.className = 'lv3-reviews-slider-item-wrap';
        newWrap.appendChild(part.cloneNode(true));

        slide.appendChild(newWrap);
        fragment.appendChild(slide);
      });
    });

    root.innerHTML = '';
    root.appendChild(fragment);
  }

  function prepareSliderDom(root) {
    saveOriginalHtml(root);
    restoreOriginalHtml(root);

    if (isMobileView()) {
      flattenForMobile(root);
    }
  }

  function getSlickSettings($, section) {
    var mobile = isMobileView();

    if (mobile) {
      return {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: false,
        variableWidth: true,
        prevArrow: section.find('.lv3-reviews-slider-arrow-prev'),
        nextArrow: section.find('.lv3-reviews-slider-arrow-next'),
      };
    }

    return {
      infinite: true,
      slidesToScroll: 1,
      swipeToSlide: true,
      variableWidth: true,
      prevArrow: section.find('.lv3-reviews-slider-arrow-prev'),
      nextArrow: section.find('.lv3-reviews-slider-arrow-next'),
    };
  }

  function initSection($, sectionEl) {
    var root = sectionEl.querySelector('.lv3-reviews-slider-row');
    if (!root) return;

    var $section = $(sectionEl);
    var $slider = $(root);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    prepareSliderDom(root);
    $slider.slick(getSlickSettings($, $section));
    root.classList.toggle('lv3-reviews-mobile-ready', isMobileView());
    root.dataset.lv3SliderMode = isMobileView() ? 'mobile' : 'desktop';
  }

  function initAll($) {
    document.querySelectorAll('.lv3-reviews-section[data-section-id]').forEach(function (sectionEl) {
      initSection($, sectionEl);
    });
  }

  function bindResize($) {
    if (window.MilaLandingV3ReviewsSliderResizeBound) return;
    window.MilaLandingV3ReviewsSliderResizeBound = true;

    var resizeTimer;

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('.lv3-reviews-section[data-section-id]').forEach(function (sectionEl) {
          var root = sectionEl.querySelector('.lv3-reviews-slider-row');
          if (!root) return;

          var currentMode = root.dataset.lv3SliderMode;
          var nextMode = isMobileView() ? 'mobile' : 'desktop';

          if (currentMode !== nextMode) {
            initSection($, sectionEl);
          }
        });
      }, 200);
    });
  }

  window.MilaLandingV3ReviewsSlider = {
    init: function ($) {
      initAll($);
      bindResize($);
    },
    initSection: initSection,
  };
})();
